import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { setBoxViewerLink, setBoxViewerMode } from './../../redux/box/actions'
import {
  boxViewLink,
  boxViewerFailureMessage,
  boxViewerFileId,
  boxViewerMode,
  isBoxViewerExpanded,
} from './../../redux/box/selectors'
import { isAdminLoggedAsClient, isExternalUser } from './../../redux/profile/selectors'
import BoxViewer, { IProps } from './BoxViewer'

const selector = createStructuredSelector({
  boxViewLink,
  boxViewerMode,
  boxViewerFileId,
  boxViewerFailureMessage,
  isBoxViewerExpanded,
  isAdminLoggedAsClient,
  isExternalUser,
})
const actions = {
  setBoxViewerLink,
  setBoxViewerMode,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, BoxViewer)
